import React, { useState, useEffect } from "react";
import squarePlus from "../../assets/images/square-plus.svg";
import Modal from "./houseImage_Modal";
import { IconSquareMinus } from "@tabler/icons-react";

const HouseItem = ({ house, type }) => {
  //console.log(house);
  const [showInfo, setShowInfo] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleShowInfo = () => {
    setShowInfo(!showInfo);
  };
  function formatNumberWithSeparators(number) {
    return number.toLocaleString("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0, // Use this to avoid decimals if not needed
    });
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === house.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? house.images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 10000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const handleImageClick = (index) => {
    setCurrentIndex(index);
    setShowModal(true);
  };
  return (
    <div className="house-card" key={house.houseId}>
      <div className="carousel-container">
        <div
          className="image-wrapper"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {house.images && house.images.length > 0 ? (
            house.images.map((image, index) => {
              //console.log(image);
              const lastItem = image.imageName.split("/").pop();
              return (
                <img
                  key={index}
                  src={
                    type === "online"
                      ? image.path
                      : require(`../../assets/images/houses/${lastItem}`)
                  }
                  alt={`Slide ${index}`}
                  className="carousel-image"
                  onClick={() => handleImageClick(index)}
                />
              );
            })
          ) : (
            <p>No images available</p>
          )}
        </div>
        {house.images.length > 1 ? (
          <>
            <div className="arrow left" onClick={prevSlide}>
              &#10094;
            </div>
            <div className="arrow right" onClick={nextSlide}>
              &#10095;
            </div>
          </>
        ) : (
          <div></div>
        )}
      </div>

      <div className="house-card-top">
        <h2>{house.houseStatus}</h2>
        <p>{house.title}</p>
      </div>
      <div className="house-card-middle">
        <p>{formatNumberWithSeparators(house.price)}</p>
        {showInfo ? (
          <IconSquareMinus onClick={handleShowInfo} stroke={2} />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-square-rounded-plus"
            onClick={handleShowInfo}
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
            <path d="M15 12h-6" />
            <path d="M12 9v6" />
          </svg>
        )}
      </div>

      <div
        className={`house-extra-info ${showInfo ? "show-info" : "hide-info"}`}
      >
        <div className="section">
          <div>
            <h4>Habitaciones</h4>
            <p>{house.rooms}</p>
          </div>
          <div>
            <h4>Parqueadero</h4>
            <p>{house.parking}</p>
          </div>
        </div>
        <div className="section">
          <div>
            <h4>Baños</h4>
            <p>{house.baths}</p>
          </div>
          <div>
            <h4>mts2</h4>
            <p>{house.squaremts}</p>
          </div>
        </div>
        <div className="description">
          <span></span>
          <p>{house.houseDescription}</p>
        </div>
        <button>Me interesa</button>
      </div>
      <Modal
        show={showModal}
        mode={type}
        onClose={() => setShowModal(false)}
        images={house.images}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      />
    </div>
  );
};

export default HouseItem;
